var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentPage = null;
        _this.total = null;
        _this.perPage = null;
        _this.from = null;
        _this.lastPage = null;
        _this.to = null;
        return _this;
    }
    Pagination.prototype.toJson = function (toSnake, asString) {
        var json = _super.prototype.toJson.call(this, toSnake, asString);
        if (this.currentPage) {
            json.page = this.currentPage;
        }
        return asString ? JSON.stringify(json) : json;
    };
    return Pagination;
}(Entity));
export { Pagination };
